<template>
  <div :class="{ videoFull: $store.state.isFullScreen }" style="height: 100%; position: relative">
    <ul id="videoNav">

      <li>
        <Dropdown>
          <Button>画面数量</Button>
          <DropdownMenu slot="list">
            <DropdownItem v-for="(item, index) in pages" :key="index">
              <p @click="mySetPlayerNum(item)" style="padding: 6px 0">
                画面×{{ item }}
              </p>
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </li>
      <li>
        <Button @click="close">全部关闭</Button>
      </li>
      <li>
        <Select @on-change="channelChange" style="width: 100px" v-model="videoModal">
          <Option v-for="(y, index1) in videoModals" :value="y" :key="y">{{
            y
          }}</Option>
        </Select>
      </li>
      <li>
        <Button @click="videoScreen">{{ $store.state.isFullScreen ? "退出全屏" : "铺满全屏" }}</Button>
      </li>
      <!-- <li @click="openControl = true">云台</li> -->
    </ul>
    <div id="bVideo-wrap">
      <div id="bVideo"></div>
    </div>
    <Modal v-model="openControl" title="云台控制" draggable footer-hide width="240" :mask="false">
      <control></control>
    </Modal>
  </div>
</template>
<script>
import { Option } from "tdesign-vue";
import control from "./control";
let playList = [];
let player = null;
let allChannelArr = [];
let tidObj = null;
export default {
  components: { control },
  data() {
    return {
      isPlay: true,
      deviceNo: "13878998877",
      openControl: false,
      arr: [
        {
          name: 111,
          children: [{ name: 222, children: [{ name: 444 }] }],
        },
        {
          name: 555,
          children: [
            {
              name: 666,
              children: [{ name: 777 }],
            },
          ],
        },
      ],
      pages: [1, 2, 4, 6, 8, 9, 13, 16, 17, 25],
      tongdao: [1, 2, 3, 4],
      tongdaoNum: 16,
      openSetPages: false,
      videoModal: '多车模式',
      videoModals: ['单车模式', '多车模式'],
      time: null
    };
  },
  methods: {
    beforCcreatePlayer() {
      if (player != null) {
        player.destroy();
        player = null;
        playList = [];
        tidObj = null;
        setTimeout(() => {
          this.isPlay = true;
          setTimeout(() => {
            this.createPlayer();
          }, 100);
        }, 100);
      } else {
        setTimeout(() => {
          this.createPlayer();
        }, 100);
      }
    },
    createPlayer() {
      var that = this;
      player = new byskplayer({
        id: "bVideo", //容器
        baseURL: "wss://videostream.car900.com/", //路径
        //baseURL: 'wss://videostream.car900.com/07B7ED0A57724C7705F2C27E13ED57DA',
        // userkey: "c4d1fbb6-2dc5-4f86-a5da-893f80e9d80a", //客户代码
        userkey: "2161e23a-4d3b-4d1a-bf0a-cafd56f9c6f8", //客户代码
        //userkey: '9c6386c7-4987-4a30-ac90-43ad22900a9f',
        isReal: true, //是否实时
        isRecord: false, //是否回放
        userId: "apidemo", //用户id,
        click: this.onPlayClick,
        playstart: this.onPlayStart,
        playend: this.onPlayEnd,
        isSwitchCodetypeOnFullscreen: false, //全屏是否切换高清，默认false
      });
      //player.poster = that.lycsr.vbg; //设置预览图片
      this.mySetPlayerNum(this.tongdaoNum); //设置视频画面
    },
    mySetPlayerNum(t) {
      player.setPlayerNum(t);
    },
    onPlayClick(e) {
      // console.log(e);
      //alert(e);
    },
    //单通道和多通道转换
    channelChange(v) {
      console.log(v);
      this.close();//多环少的时候要先关掉，避免视频遗漏不管
      if (v == '单车模式') {
        this.tongdaoNum = 4;

      } else {
        this.tongdaoNum = 16;//打开九个窗口
      }
      player.setPlayerNum(this.tongdaoNum); //设置视频画面
    },
    open(aaa) {
      if (this.videoModal == '单车模式') {
        this.close();
      }
      this.$emit('openVideo');
      clearTimeout(this.time)
      this.time = setTimeout(() => {
        //13305876769
        this.deviceNo = aaa.deviceNo;
        var length = this.tongdao.length; //默认视频个数
        this.tongdao = [];
        if (!this.utils.isEmpty(aaa.videoConfig)) {
          length = aaa.videoConfig.length;
        }
        for (let i = 0; i < length; i++) {
          this.tongdao.push(i + 1);
        }
        let SpecialSign = 0; //0不处理 1--粤标
        let playerType = 0; //播放器类型 0: video(默认), 1: webgl
        if (
          aaa.deviceProtocol.indexOf("粤标") != -1 ||
          aaa.deviceProtocol.indexOf("809") != -1
        ) {
          this.deviceNo = "000000000" + aaa.deviceNo;
          SpecialSign = 1; //0不处理 1--粤标
        }
        if (aaa.deviceModel.indexOf("GH11") != -1) {
          playerType = 1;
          console.log('GH11触发成功')
        }
        let device = this.deviceNo;
        let channel = 1;
        let protocolType = 1;
        let obj = playList.find(
          (p) => p.device == device && p.channel == channel
        );
        if (obj) return; //已经在播放的则不能再播放

        //const channelArr123 = channel.split(",").map(p => p * 1);
        // console.log(channelArr123);
        // const channelArr = [1, 2, 3, 4];
        allChannelArr.push(aaa.now);
        //allChannelArr=[now]
        const channelArr = this.tongdao;
        const tidObj = player.allocate(channelArr.length); //根据通道数申请
        // let tidObj = player.allocate(1); //申请一个视频播放器
        if (tidObj.flag == 1) {
          //申请成功
          let params = {
            SpecialSign: SpecialSign,
            device: device, //终端号
            channel: channel, //通道号 （1~8）
            protocolType: protocolType, //协议类型，1：GF-1078，GB-1078; 2：GA系列
            codeTypeCtrlBtnEnabled: protocolType === 1, //是否显示高标清切换按钮(GF才有高清)
            playerType: playerType, //播放器类型 0: video(默认), 1: webgl
          };

          if (protocolType === 1) {
            //1078
            for (let i = 0; i < channelArr.length; i++) {
              const tid = tidObj.ids[i];
              const param = {
                ...params,
                channel: channelArr[i],
              };
              player.real.open(tid, param, (res) => {
                // console.log(res);
                this.isPlay = false;
              });
              playList.push({
                ...param,
              });
            }
          } else if (protocolType === 2) {
            //GA
            player.real.open(tidObj.ids, params, (res) => {
              // console.log(res);
              this.isPlay = false;
            });
            playList.push(
              ...tidObj.ids.map((p, i) => {
                return {
                  ...params,
                  channel: channelArr[i],
                };
              })
            );
          }
        } else {
          //申请失败
          alert(tidObj.msg);
        }
      }, 500);
    },
    pause1(aaa) {
      let device = aaa.deviceNo;
      let channel = 1;
      //const channelArr = channel.split(",").map(p => p * 1);
      //const channelArr = [channel];
      const channelArr = this.tongdao;
      for (let i = 0; i < channelArr.length; i++) {
        let index = playList.findIndex(
          (p) => p.device == device && p.channel == channelArr[i]
        );
        let obj = playList[index];
        console.log(index);
        if (obj)
          player.real.close(
            obj.tid,
            {
              device: device,
              channel: obj.channel,
              protocolType: obj.protocolType,
            },
            (res) => {
              this.isPlay = true;
            }
          );
        playList.splice(index, 1);
      }
    },
    pause(aaa) {
      let device = aaa.deviceNo;
      if (
        aaa.deviceProtocol.indexOf("粤标") != -1 ||
        aaa.deviceProtocol.indexOf("809") != -1
      ) {
        //SpecialSign=1;
        device = "000000000" + device;
      }
      let channel = 1;
      //const channelArr = channel.split(",").map(p => p * 1);
      //const channelArr = [channel];
      const channelArr = this.tongdao;
      for (let i = 0; i < channelArr.length; i++) {
        let index = playList.findIndex(
          (p) => p.device == device && p.channel == channelArr[i]
        );
        let obj = playList[index];
        if (obj)
          player.real.close(
            obj.tid,
            {
              device: device,
              channel: obj.channel,
              protocolType: obj.protocolType,
            },
            (res) => {
              this.isPlay = true;
            }
          );
        playList.splice(index, 1);
      }
    },
    onPlayStart(e) {
      this.isPlay = false;
      let index = playList.findIndex(
        (p) => p.device == e.device && p.channel == e.channel
      );
      let obj = playList[index];
      if (obj) return;
      playList.push({
        ...e,
      });
    },
    onPlayEnd(e) {
      let index = playList.findIndex(
        (p) => p.device == e.device && p.channel == e.channel
      );
      playList.splice(index, 1);
    },
    //全部关闭
    close() {

      for (let i = 0; i < playList.length; i++) {

        let obj = playList[i];
        if (obj)
          player.real.close(
            obj.tid,
            {
              device: obj.device,
              channel: obj.channel,
              protocolType: obj.protocolType,
            },
            (res) => {
              this.isPlay = true;
            }
          );

      }
      playList.splice(0, 100);
      this.$emit('closeVideo');
      /* {
    "SpecialSign": 0,
    "device": "14431101629",
    "channel": 2,
    "protocolType": 1,
    "codeTypeCtrlBtnEnabled": true,
    "playerType": 0
} */
      return;
      player.destroy();
      player = null;
      playList = [];
      tidObj = null;
      this.isPlay = true;
      this.$emit("closeVideo");
      this.videoModal = false;
    },

    dasf() {
      this.$Message.info("即将开放，敬请期待");
    },
    //视频满屏
    setScreen() {
      this.$store.state.isMapScreen = !this.$store.state.isMapScreen;
    },
    setPages() {
      this.tongdao = [];
      for (let i = 1; i <= this.tongdaoNum; i++) {
        this.tongdao.push(i);
      }
    },
    videoScreen() {
      document.getElementById("fullScree").click();
    },
  },
  mounted() {
    /* setTimeout(() => {
      var s = document.createElement("script");
      s.type = "text/javascript";

      s.src = "static/js/byskplayer.js";
      var m = document.getElementById("byscript");
      m.appendChild(s);
    }, 200); */

    setTimeout(() => {
      this.beforCcreatePlayer();
    }, 300);
  },
  destroyed() {
    this.close();
    location.reload();
  },
};
</script>
<style lang="">
#videoNav {
  width: 100%;
  height: 40px;
  background: #fff;
  line-height: 40px;
}
#videoNav li {
  padding: 0 0 0 20px;
  float: left;
  cursor: pointer;
}
#videoNav li:hover {
  color: red;
}
#bVideo-wrap {
  background: #ccc;
  height: calc(100% - 50px);
  width: 100%;
}
.videoFull{
  position:fixed!important;
  left:0;
  top:0;
  z-index:2222;
  width:100%;
}
/* #bVideo .bysk-p-layout-view .layout-4 .num {
  position: absolute !important;
  left: auto !important;
  margin-bottom: 2px;
  outline: solid 8px #fff;
  width: auto;
  height: auto;
} */
</style>


// WEBPACK FOOTER //
// src/components/video/bsjVideo.vue